namespace ui
{
	export namespace table
	{
		export namespace model
		{
			export interface ICardModelDescriptor
				extends ui.base.IBaseHTMLElementDescriptor
			{
				number: number;
				style?:
				{
					hover?: boolean;
				};
			}

			export abstract class AbstractCardModel<T>
				extends ui.table.DataModel<T>
			{
				private m_Descriptor: ICardModelDescriptor;

				public constructor( descriptor?: ICardModelDescriptor )
				{
					super();

					this.m_Descriptor					= descriptor || { number: 10 };

					this.m_Descriptor.classes	= this.m_Descriptor.classes || [];
					this.m_Descriptor.number	= clamp( this.m_Descriptor.number, 1, 10 );

					this.m_Descriptor.classes.push( 'flex-' + this.m_Descriptor.number );
				}

				protected build(): JQuery<HTMLElement>
				{
					const cardlist	= new ui.base.BaseHTMLElement( 'card-list' );

					cardlist.Initialize( this.m_Descriptor );

					if ( this.m_Descriptor.style && this.m_Descriptor.style.hover )
					{
						cardlist.addClass( 'hover' );
					}

					if ( this.m_DataReader )
					{
						this.m_DataReader.GenerateDatafields().forEach(
							( card: JQuery, index: number ): void =>
							{
								cardlist.append( card );
							}
						);
					}

					return cardlist.Root();
				}
			}

		}
	}
}
